<template lang="html">
  <div class="question">
    <h4 @click="expandQuestion" :href="'#question-' + this.id" class="interview-question">
      {{ question }}
      <small v-if="questionExtended" class="small-text">expanded</small>
      <small class="interview-validation"></small>
    </h4>
    <div class="set-after" v-if="validation">
      <label :for="'comment' + this.id">Your comment (optional)</label>
      <textarea :name="'questions[' + this.id + '][comment]'"
                :id="'comment' + this.id"
                :disabled="disabled"
                cols="30"
                rows="3"
                class="long-input">{{ answer['comment'] }}</textarea>
    </div>
    <div class="message-box warning-message" v-if="answer.comment && !validation">
      <p>{{ answer.comment }}</p>
    </div>
    <div :id="'question-' + this.id" :data-id="this.id" v-if="!loading">
      <expanded-question v-if="questionIsReady"
                         :class="{ hidden: !questionExtended }"
                         :id="this.id"
                         :answer="restoredQuestion.answer ? restoredQuestion.answer : answer"
                         :validation="validation"
                         :disabled="disabled"
                         :route-upload-video="routeUploadVideo"
                         :fullQuestion="restoredQuestion.fullQuestion ? restoredQuestion.fullQuestion : fullQuestion"
                         entity="interview"
      ></expanded-question>
    </div>
  </div>
</template>

<script>
// Component to display single question. Used for interview page

export default {
  props: ['id', 'question', 'answeredQuestions', 'validation', 'routeUploadVideo', 'disabled', 'fullQuestion'],
  data() {
    return {
      questionExtended: false,
      answer: {},
      questionIsReady: false,
      loading: true,
      restoredQuestion: {
        fullQuestion: null,
        answer: null,
      },
    };
  },
  methods: {
    expandQuestion() {
      this.questionExtended = !this.questionExtended;
    },
    fillRestoredQuestionData(question) {
      this.restoredQuestion.fullQuestion = {
        id: question.id,
        status: 1,
        type: 0,
        images: question.images,
        question: this.fullQuestion.question,
      };

      this.restoredQuestion.answer = {
        images: [],
        comment: '',
        answer: question.answerText,
        draft_id: question.draftId,
        question_id: question.id,
        video_name: question.videoName,
        video_path: question.videoPath,
      };

      this.expandQuestion();
    },
    checkLocalStorageQuestions() {
      let storageData = localStorage.getItem('interview');
      if (!storageData) return;

      storageData = JSON.parse(storageData);
      if (!storageData.hasOwnProperty('questions')) return;

      let questionIndex = storageData.questions.findIndex(question => question.id == this.id);
      if (questionIndex === -1) return;

      this.fillRestoredQuestionData(storageData.questions[questionIndex]);

      //Remove restored question from local torage
      // storageData.questions.splice(questionIndex, 1);
      // localStorage.setItem('interview', JSON.stringify(storageData));
    },
  },
  created() {
    this.checkLocalStorageQuestions();
    this.loading = false;

    this.$emit('question-ready');
  },
  mounted() {
    if (this.answeredQuestions) {
      this.answeredQuestions.forEach((answeredQuestion) => {
        if (answeredQuestion.question_id === this.id) {
          this.expandQuestion();
          this.answer = answeredQuestion;
        }
      });
    }
    this.questionIsReady = true;
  }
};
</script>

<style>
  small.interview-validation {
    color: red;
    font-size: 12px;
  }
</style>